import * as React from 'react';
import { Photo16, Video16 } from '@cian/ui-kit/icons';
import { ImageNone } from '@cian/image-none-component';

import * as styles from './Photo.css';

interface IPhotoProps {
  photoUrl: string | null;
  photoCount: number;
  videoCount: number;
}

export const Photo: React.FC<IPhotoProps> = ({ photoUrl, photoCount, videoCount }) => {
  return (
    <div className={styles.root}>
      {photoUrl && <img src={photoUrl} className={styles.image} />}

      {!photoUrl && (
        <ImageNone
          bgColor="#e8e9ec"
          iconColor="#ced1d7"
          containerStyle={{
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        />
      )}

      <div className={styles.labels}>
        {!!videoCount && renderLabel(<Video16 color="white_100" />, videoCount)}
        {!!photoCount && renderLabel(<Photo16 color="white_100" />, photoCount)}
      </div>
    </div>
  );
};

function renderLabel(icon: React.ReactNode, count: number) {
  return (
    <span className={styles.label}>
      {icon}
      <span className={styles['label-count']}>{count}</span>
    </span>
  );
}
